import React, { useEffect, useState } from "react";
import { Form, Button, Input } from "antd";
import { IteamFormModal } from "./IteamFormModal";
import { ContainerModal } from "../../container/ContainerModal";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";

const inputByClient = {
	name: { name: "Nombre", rules: [] },
	companyName: {
		name: "Empresa",
		rules: [
			{
				required: true,
				message: "Por favor necesita compañia!",
			},
		],
	},
	email: {
		name: "Email",
		rules: [
			{
				type: "email",
				message: "No es un email!",
			},
			{
				required: true,
				message: "Por favor necesita email!",
			},
		],
	},
	rol: { name: "Rol", rules: [] },
};

export const FormCliente = ({ dataForm = [], editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const [disableInputs, setDisableInputs] = useState(dataForm.map((_, index) => index));
	const [selectInputCliente, setSelectInputCliente] = useState(-1);

	useEffect(() => {
		form.setFieldsValue({
			clientInformation: dataForm,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const editIndexValue = (inputIndex, type = 0) => {
		const changueDisibale = [...disableInputs];
		const indexSelect = changueDisibale.indexOf(inputIndex);
		if (indexSelect !== -1) {
			changueDisibale.splice(indexSelect, 1);
			if (type === 0) {
				setSelectInputCliente(indexSelect);
			} else {
				setSelectInputCliente(-1);
			}
		}
		setDisableInputs(changueDisibale);
	};

	const finishForm = async ({ clientInformation }) => {
		setLoading(true);
		const newClientInput = clientInformation.map((client) => {
			const jsonClient = {};
			for (const [key, value] of Object.entries(client)) {
				jsonClient[key] = value === undefined ? "" : value;
			}
			return jsonClient;
        });

        await editFormForProjectDetails(typeForDetailsProyect.client, { client: newClientInput });
        setLoading(false);
	};

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={"Editar cliente"}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<Form form={form} onFinish={finishForm} className="w-full h-full">
					<div className="max-h-[550px] overflow-y-scroll scroll-project-details">
						<Form.List name="clientInformation">
							{(fields, { add, remove }) => {
								if (fields.length === 0) {
									return (
										<div className="h-[40px] w-full">
											<Button
												onClick={() => {
													add();
												}}
												htmlType="button"
											>
												Agregar Clientes
											</Button>
										</div>
									);
								}
								return (
									<>
										{fields.map(({ key, name, ...restField }, indexFields) => {
											let buttonDownExtra = <></>;
											let buttonAddClient = <></>;

											let disableInput = disableInputs.includes(key);

											let disableExtraButtons = selectInputCliente === -1 ? false : key !== selectInputCliente;
											if (disableInputs.length !== fields.length) {
												disableExtraButtons = true;
											}

											if (disableInputs.includes(key)) {
												buttonDownExtra = (
													<div className="h-[40px] w-full flex gap-4">
														<button
															onClick={() => {
																editIndexValue(key);
															}}
															disabled={disableExtraButtons}
														>
															<p
																className={` ${
																	disableExtraButtons ? "text-gray-300" : "text-primaryTwo cursor-pointer"
																}`}
															>
																Editar Cliente
															</p>
														</button>
														<button
															onClick={() => {
																if (fields.length - 1 === 0) {
																	editIndexValue(key, 1);
																	form.setFieldsValue({
																		clientInformation: [
																			{
																				name: "",
																				companyName: "",
																				email: "",
																				rol: "",
																			},
																		],
																	});
																	return;
																}

																remove(name);
																editIndexValue(key, 1);
															}}
															disabled={disableExtraButtons}
														>
															<p
																className={` ${
																	disableExtraButtons ? "text-gray-300" : "text-[#E4404B] cursor-pointer"
																}`}
															>
																Eliminar Cliente
															</p>
														</button>
													</div>
												);
											}

											if (fields.length - 1 === indexFields && fields.length > 0) {
												buttonAddClient = (
													<div className="h-[40px] w-full">
														<Button
															disabled={disableInputs.length !== fields.length}
															onClick={() => {
																add();
															}}
															htmlType="button"
														>
															Agregar Clientes
														</Button>
													</div>
												);
											}
											return (
												<IteamFormModal key={key} title="Información del cliente ">
													<div className="">
														{Object.entries(inputByClient).map(([keyObject, value], index) => {
															return (
																<div key={`${key}-${index}-cliente`}>
																	<p>{value.name}</p>
																	<Form.Item {...restField} name={[name, keyObject]} rules={value.rules}>
																		<Input placeholder="Nombre" disabled={disableInput} />
																	</Form.Item>
																</div>
															);
														})}
													</div>
													{buttonDownExtra}
													{buttonAddClient}
												</IteamFormModal>
											);
										})}
									</>
								);
							}}
						</Form.List>
					</div>
					<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
						<Button htmlType="button" onClick={closeModalDetails}>
							Cancelar
						</Button>
						<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
							Guardar
						</Button>
					</div>
				</Form>
			</ContainerModal>
		</div>
	);
};
